import { TabNavigation } from 'components/ui/TabNavigation';
import {
  SpreadsheetViewerFormulaBar,
  SpreadsheetViewerInitialLoadOverlay,
  SpreadsheetViewerLoadingSpinner,
  SpreadsheetViewerScrollContainer,
  SpreadsheetViewerSheetNavigation,
  SpreadsheetViewerStateContainer,
  SpreadsheetViewerWrapper,
} from './SpreadsheetViewer.styles';
import type { SpreadsheetWorkbookViewerProps } from './SpreadsheetWorkbookViewer.props';

const SpreadsheetWorkbookViewer = ({
  actions,
  ariaLabel,
  children,
  contentVariant = 'standard',
  emptyMessage,
  emptyTitle,
  errorMessage,
  errorTitle,
  formulaBar,
  isLoading = false,
  loadingMessage = 'Preparing spreadsheet preview...',
  navigationZoomLevel = 1,
  onKeyDown,
  onSheetChange,
  scrollContainerProps,
  scrollContainerRef,
  sheetItems = [],
  testId,
  value = false,
}: SpreadsheetWorkbookViewerProps) => {
  if (isLoading) {
    return (
      <SpreadsheetViewerWrapper aria-busy="true" aria-label={ariaLabel} data-testid={testId}>
        <SpreadsheetViewerInitialLoadOverlay>
          <SpreadsheetViewerLoadingSpinner size={22} />
          {loadingMessage}
        </SpreadsheetViewerInitialLoadOverlay>
      </SpreadsheetViewerWrapper>
    );
  }

  if (errorTitle || errorMessage) {
    return (
      <SpreadsheetViewerWrapper aria-label={ariaLabel} data-testid={testId}>
        <SpreadsheetViewerStateContainer>
          {errorTitle ? <strong>{errorTitle}</strong> : null}
          {errorMessage ? <span>{errorMessage}</span> : null}
        </SpreadsheetViewerStateContainer>
      </SpreadsheetViewerWrapper>
    );
  }

  if (emptyTitle || emptyMessage) {
    return (
      <SpreadsheetViewerWrapper aria-label={ariaLabel} data-testid={testId}>
        <SpreadsheetViewerStateContainer>
          {emptyTitle ? <strong>{emptyTitle}</strong> : null}
          {emptyMessage ? <span>{emptyMessage}</span> : null}
        </SpreadsheetViewerStateContainer>
      </SpreadsheetViewerWrapper>
    );
  }

  return (
    <SpreadsheetViewerWrapper aria-label={ariaLabel} data-testid={testId} onKeyDown={onKeyDown}>
      {sheetItems.length ? (
        <SpreadsheetViewerSheetNavigation>
          <TabNavigation
            actions={actions}
            ariaLabel="Workbook sheets"
            items={sheetItems}
            onChange={onSheetChange}
            showScrollButtons
            value={value}
            zoomLevel={navigationZoomLevel}
          />
        </SpreadsheetViewerSheetNavigation>
      ) : null}
      {formulaBar ? (
        <SpreadsheetViewerFormulaBar>
          {formulaBar}
        </SpreadsheetViewerFormulaBar>
      ) : null}
      <SpreadsheetViewerScrollContainer
        {...scrollContainerProps}
        ref={scrollContainerRef}
        data-content-variant={contentVariant}>
        {children}
      </SpreadsheetViewerScrollContainer>
    </SpreadsheetViewerWrapper>
  );
};

export default SpreadsheetWorkbookViewer;
